import { useEffect } from 'react'

const useHtmlTitle = (title) => {
  useEffect(() => {
    document.title = `SLS24${title ? ': ' : ''}${title}`
  }, [title])
}

export default useHtmlTitle
